const isEqualArrays = (firstArr: Array<any>, secondArr: Array<any>) =>
  firstArr.length === secondArr.length &&
  firstArr.sort().toString() === secondArr.sort().toString();

export default isEqualArrays;
